import { QRDecoderDebugger } from 'debug_tools';

const video = document.createElement("video");
const cameraCanvasElement = document.getElementById("cameraCanvas");
const greyscaleCanvasElement = document.getElementById("greyscaleCanvas");
const binaryCanvasElement = document.getElementById("binaryCanvas");
const adaptiveThresholdingElement = document.getElementById("adaptiveThresholdingBinaryCanvas")

const croppedCanvasElement = document.createElement("canvas");

const cameraCanvas = cameraCanvasElement.getContext("2d");

async function getPermission(){
  const stream = await navigator.mediaDevices.getUserMedia({ video: {facingMode: "environment"}});
  video.srcObject = stream;
  video.setAttribute("playsinline", true);
  video.play();
  const videoTrack = stream.getVideoTracks()[0];
  checkAndUpdateZoomSlider(videoTrack);
  window.stream = stream;
}

async function getCameras(){
  const devices = await navigator.mediaDevices.enumerateDevices();
  const cameras = devices.filter(device => device.kind === "videoinput");

  const select = document.getElementById("cameraSelect");
  select.innerHTML = '';

  cameras.forEach(camera => {
    const option = document.createElement('option');
    option.value = camera.deviceId;
    option.text = camera.label || `Camera ${select.length + 1}`;
    select.appendChild(option);
  });
}

function checkAndUpdateZoomSlider(videoTrack){

  const capabilities = videoTrack.getCapabilities();
  const settings = videoTrack.getSettings();
  if ('zoom' in settings){
    // means that the camera supports zoom
    const slider = document.getElementById("zoomSlider");
    slider.max = capabilities.zoom.max;
    slider.min = capabilities.zoom.min;
    slider.value = settings.zoom;
    slider.hidden = false;
  } else {

    const slider = document.getElementById("zoomSlider");
    slider.hidden = true;
  }
}

function updateZoom(videoTrack, value){
  videoTrack.applyConstraints({
    advanced: [{
      zoom: value
    }]
  });
}

async function startCamera(deviceId){
  if (window.stream) {
    window.stream.getTracks().forEach(track => track.stop());
  }
  const constraints = { video: { deviceId: deviceId? { exact: deviceId } : undefined } , audio: false };
  const stream = await navigator.mediaDevices.getUserMedia(constraints);
  window.stream = stream;
  const videoTrack = stream.getVideoTracks()[0];
  checkAndUpdateZoomSlider(videoTrack);
  videoTrack.applyConstraints({ advanced: [{focusMode: "auto"}]});
  video.srcObject = stream;
  video.play();
}

document.getElementById("cameraSelect").addEventListener("change", (event) => {
  startCamera(event.target.value);
  setupOverlay()
});

document.getElementById("zoomSlider").addEventListener("input", (event) => {

  const value = parseFloat(event.target.value);
  const videoTrack = window.stream.getVideoTracks()[0];

  updateZoom(videoTrack, value);
})

const FOCUS_ZONE = 200;

function setupOverlay(){

  const focusZone = FOCUS_ZONE;
  const cornerRadius = 20;
  const startX = (video.videoWidth - focusZone) / 2;
  const startY = (video.videoHeight - focusZone) / 2;

  const svg = `
    <svg width="0" height="0" xmlns="http://www.w3.org/2000/svg">
    <defs>
    <mask id="dynamicMask">
    <rect x="0" y="0" width="${video.videoWidth}" height="${video.videoHeight}" fill="white"/>
    <rect x="${startX} " y="${startY}" width="${focusZone}" height="${focusZone}" rx="${cornerRadius}" ry="${cornerRadius}" fill="black"/>
    </mask>
    </defs>
    </svg>
    `;

  const overlay = document.querySelector('.overlay');
  // Inject the SVG into the overlay
  overlay.innerHTML = svg;

  overlay.style.mask = "url(#dynamicMask)";
  overlay.style.webkitMask = "url(#dynamicMask)";
}

let videoState = "initialization";
let overlayState = "waiting";

function tick(){

  if(video.readyState === video.HAVE_ENOUGH_DATA){

    cameraCanvasElement.hidden = false;

    const focusZone = FOCUS_ZONE;
    cameraCanvasElement.height = video.videoHeight;
    cameraCanvasElement.width = video.videoWidth;

    croppedCanvasElement.height = focusZone;
    croppedCanvasElement.width = focusZone;
    const croppedCanvas = croppedCanvasElement.getContext("2d");

    greyscaleCanvasElement.hidden = false;
    binaryCanvasElement.hidden = false;
    adaptiveThresholdingElement.hidden = false;

    const startX = (video.videoWidth - focusZone) / 2;
    const startY = (video.videoHeight - focusZone) / 2;

    cameraCanvas.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
    croppedCanvas.drawImage(video, startX, startY, focusZone, focusZone, 0, 0, focusZone, focusZone);

    const qrDebugger = new QRDecoderDebugger()
      .withGreyScaleCanvas(greyscaleCanvasElement)
      .withBinaryImage(binaryCanvasElement)
      .withAdaptiveThresholding(adaptiveThresholdingElement)
      .showProjectionLines()
      .tryDecode()
      .showLocations();

    qrDebugger.visualizeFrame(croppedCanvasElement);
    videoState = "playing";
  }

  if(videoState === "playing" && overlayState === "waiting"){
    overlayState = "playing";
    setupOverlay();
  }
  requestAnimationFrame(tick);
}

getPermission().then(getCameras).then(() => {

  requestAnimationFrame(tick);
})
